import React, {useEffect, useRef,useState } from "react"; 
import { getEnvUrl,getToken } from "../../../utils/Api";
import './gameList.css' 
import CreateGame from "./popups/createGame"; 
import Loader from "../../common/loader";
import  {gameDelete} from "../../../Services/gameServices" 
import { toast } from 'react-toastify'; 
import {getSubjects} from "../../../Services/Subjects/SubjectServices"
import  {getCategories} from "../../../Services/gameServices" 
import { useNavigate } from "react-router-dom";
import { checkPermissions } from "../../../Services/User/User";
const $ = require("jquery");
require("datatables.net");
const GameList = ({ data }) => {
   const tableRef = useRef(null); 
   const [isLoading, setIsLoading] = useState(true);
   const [createGameModal, setCreateGameModal] = useState(false);
   const [subjects, setSubjects]           = useState([]); 
   const [categoryData, setCategoryData]  = useState([]);
   const [subjectId, setSubjectId] = useState('');
   const [gameLevelId, setGameLevelId] = useState(''); 
  const [render, setRender] = useState(true);  
  const navigate = useNavigate();
  let reRender=()=>{
    setRender(!render)
  }
  let createGameModalClose=()=>{
   setCreateGameModal(false)
 }
 let deleteGame=(gameid)=>{
   if (window.confirm('Are you sure you want to delete this game?')){
    gameDelete({id:gameid,active:false}).then((data)=>{
      if(data.status){
        toast.success('Game deleted successfully')
      }else{
        toast.error('Somthing went wrong')
      }
      reRender()
    })
  }
  
} 
let reset=()=>{
   setSubjectId('');setGameLevelId('');
   setCategoryData([])
 } 
 useEffect(() => {   
  if(!checkPermissions('games_list_page') || !checkPermissions('games_navigation')){ 
    navigate('/')
  }
    getSubjects().then((data)=>{
        if(data.status){
          setSubjects(data.data) 
        }
      }) 
  }, []); 
  useEffect(() => {
    // Initialize DataTable
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/game/getGameListReport?category=${gameLevelId}&subject=${subjectId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        }
      },
      columns: [
                { data: "gameid" },
                { data: "gamename" },
                { data: "subject" },
                { data: "category" },
                { data: "game_status" },
                { 
                  data: null,
                  title: 'Actions',
                  render:  (data, type, row) => (
                    `<div> 
                    <span class="a-view"><i class="bi bi-eye-fill"></i></span>
                    <span class="a-delete"><i class="bi bi-trash-fill"></i></span>
                    </div>`
                  )
                    },
              ],
              createdRow: (row, data, dataIndex) => {  
                if(!checkPermissions('game_view')){
                  $(row).find('.a-view').remove();
                }
                if(!checkPermissions('game_delete')){
                  $(row).find('.a-delete').remove();
                }
              $(row).find('.a-view').on('click', () => navigate(`/games/gameDetailView/${data.gameid}`) );
               $(row).find('.a-delete').on('click', () => deleteGame(data.gameid) );
              },
              'columnDefs': [ {
                'targets': [5], /* column index */
                'orderable': false, /* true or false */ 
             }],
             drawCallback: function(settings) {
              setIsLoading(false);
            },
              aaSorting: [[0, "desc"]],
    });

    return () => {
      // Destroy DataTable when component unmounts to avoid memory leaks
      table.destroy();
    };
  }, [data,render,subjectId,gameLevelId]);

  
  const retriveCategories=(id)=>{
      getCategories(id)
      .then((data) => { 
          setCategoryData(data?.status ? data.data : []);
      })
      .catch((error) => {
          console.error("Error fetching categories:", error);
          setCategoryData([]);
      });
      }

  const callCategories = (e) => { 
    const value = e.target.value;
    setSubjectId(value); 
    setGameLevelId(''); 
    if (value !== "") {
      retriveCategories(value)
    } else {
        setCategoryData([]);
    }
  }; 
  
  const exportReport = () => {
    console.log("exportReport");
    window.location.href = `${getEnvUrl()}/admin/game/gamelistDownload?subject=${subjectId}&category=${gameLevelId}`;
  };
  
 
  return (
    <div>
   <main id="main" className="main">
      <div className="pagetitle">
         <h1>Game List</h1>
      </div>
      <section className="section">
         <div className="row">
            <div className="col-lg-12">
               <div className="card p-10">
                     <h5 className="card-title ">
                      {checkPermissions("game_create") && <>
                        <button id="addgameid" type="button" 
                     className="btn btn-primary float-right" 
                     onClick={()=>{setCreateGameModal(true)}}>+ Add game</button>
                   
                      </>}
                      </h5>
                     <div className="row g-1">
                        <div className="col-md-6 col-lg-3 mb-2">
                           {/* <select className="form-control" id="subjectfilter">
                              <option value="">--Select Subject--</option>
                           </select> */}
                           <select
                                 className="form-control"
                                 value={subjectId}
                                 onChange={callCategories}
                              >
                                 <option value="">--Select Subject--</option> 
                                 {subjects.map((data)=>{
                                    return (<>
                                    <option value={data.id}>{data.name}</option>
                                    </>)
                                 })}
                              </select>
                        </div>

                        <div className="col-md-6 col-lg-3 mb-2">
                           <select className="form-control" value={gameLevelId}
                              onChange={(e) => { setGameLevelId(e.target.value); }} disabled={!subjectId}
                              >
                              <option value="">--Select Category--</option>
                              {categoryData.map((data)=>{
                                 return (<>
                                    <option value={data.id}>{data.name}</option>
                                 </>)
                                 })}
                           </select>
                        </div>
                        <div className="col-md-6 col-lg-3 mb-2 d-flex align-items-end justify-content-start">
                    <button className="btn btn-primary" onClick={reset} disabled={!subjectId} >Reset</button>
                        </div>
                     </div>
                     {isLoading?
                     <Loader />
                     :"" }
                     <div className={isLoading?'card-body hide':'card-body'}>                
                     <table
                        className="mt-20 table table-striped table-hover table-bordered no-footer dataTable"
                        width="100%"
                        ref={tableRef}
                        >
                        <thead>
                           <tr>
                              <th>Game Id</th>
                              <th>Game Name</th>
                              <th>Subject</th>
                              <th>Category</th>
                              <th>Status</th>
                              <th>Action</th>
                           </tr>
                        </thead>
                     </table>
                  </div>
               </div>
            </div>
</div>
</section>
</main>  
{createGameModal && <CreateGame reRender={reRender} isShow={createGameModal} close={createGameModalClose}  /> }
 
</div>
  );
};

export default GameList;